export default {"src":"/portal/_next/static/media/lock.ec983cc0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};